import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createSimoDevice } from 'actions/simoDevices';
import withSimoAccounts from 'decorators/withSimoAccounts';
import CreateSimoDeviceForm from 'components/simo/CreateSimoDeviceForm';
import Spinner from 'components/Spinner';
import { compose } from 'redux';
import userPage from 'decorators/userPage';

class CreateSimoDevice extends Component {
  state = {
    loading: false,
  };

  handleSubmit = (values) => {
    const { createSimoDevice, history, match } = this.props;
    const userId = match?.params?.userId;
    this.setState({ loading: true });

    const params = {
      ...values,
      user_profile: userId,
    };

    return createSimoDevice(params)
      .then((res) =>
        history.push(
          `/users/${userId}/simo/new-subscription?device_id=${res.id}&device_sn=${res.serial_number}`,
        ),
      )
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { simoAccounts } = this.props;
    const { loading } = this.state;

    return (
      <div>
        <h1>Create Simo Device</h1>
        <CreateSimoDeviceForm
          simoAccounts={simoAccounts}
          onSubmit={this.handleSubmit}
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  createSimoDevice,
};

export default compose(
  userPage,
  withSimoAccounts,
  connect(mapStateToProps, mapDispatchToProps),
)(CreateSimoDevice);
